import Feature from "ol/Feature";
import { Point, LineString } from "ol/geom";
import VectorSource from "ol/source/Vector";
import { Style, Circle, Stroke, Fill, Icon } from "ol/style";
import * as format from "ol/format";
// import { transformExtent } from 'ol/proj'
class Typhoon {
  constructor(callback, data, typhoonIcon, lineColor) {
    console.log(lineColor);
    return this.createTrack(callback, data, typhoonIcon, lineColor);
  }

  createTrack(callback, data, typhoonIcon, lineColor) {
    const vectorSource = new VectorSource();
    let trackInfo = {};
    let lastLivePoint;
    for (let index = 0; index < data.length; index++) {
      const pointData = data[index];
      const coordinate = [pointData.longitude, pointData.latitude];
      if (pointData.type !== "forecast") {
        lastLivePoint = pointData;
        this.lastPoint = pointData;
      }
      const feature = new Feature({ geometry: new Point(coordinate) });
      feature.set("mark", "typhoon");
      feature.set("data", pointData);
      const typhoonLevel = {
        CZ: [0, 0, 0, 1],
        TD: [67, 255, 75, 1],
        TS: [39, 121, 249, 1],
        STS: [220, 225, 73, 1],
        TY: [230, 177, 60, 1],
        STY: [230, 47, 59, 1],
        SUPERTY: [220, 133, 243, 1],
      };

      const color = typhoonLevel[pointData.tcRank];
      // 画圆点；最后实况点会再用 gif 覆盖
      feature.setStyle(
        new Style({
          image: new Circle({
            radius: 3,
            fill: new Fill({ color: color }),
          }),
          zIndex: 2,
        }),
      );
      if (pointData.type !== "forecast") {
        this.lastLiveFeature = feature;
      }
      // 赋予点击事件
      feature.on("singleclick", () => callback(pointData));
      vectorSource.addFeature(feature);
      if (index > 0) {
        const lineArray = [];
        lineArray.push(trackInfo.coordinate); // 上一轮的台风点坐标
        lineArray.push(coordinate); // 当前的台风点坐标
        const linFeature = new Feature({
          geometry: new LineString(lineArray),
        });
        let lineDash = null;
        // 如果是预测数据：
        if (pointData.type === "forecast") {
          lineDash = [5];
        }
        linFeature.setStyle(
          new Style({
            stroke: new Stroke({
              color: lineColor || "red",
              width: 1,
              lineDash: lineDash,
            }),
          }),
        );
        vectorSource.addFeature(linFeature);
      }
      // 记录当台风点的颜色和中心点坐标，供下一轮连线的操作使用
      trackInfo = { color: color, coordinate: coordinate };
    }
    // 用台风 gif 替换实况最后一个蓝色中心点
    if (typhoonIcon && lastLivePoint && this.lastLiveFeature) {
      this.setTyphoonGifIcon(this.lastLiveFeature, typhoonIcon);
    }
    // 最后一个点风圈
    // const levels = { rd06: '#00FF00', rd07: '#0000FF', rd08: '#FFFF00', rd10: '#F59A23', rd12: '#FF0000' }
    // for (const level in levels) {
    //   if (lastLivePoint[level]) {
    //     let rd = lastLivePoint[level].split(',')
    //     rd.forEach((element, index) => { rd[index] = element * 1000 })
    //     rd = transformExtent(rd, 'EPSG:3857', 'EPSG:4326')
    //     const config = {
    //       x: Number(lastLivePoint.longitude), // 台风圈中心点经度
    //       y: Number(lastLivePoint.latitude), // 台风圈中心点维度
    //       r: {
    //         SE: rd[3],
    //         NE: rd[2],
    //         NW: rd[1],
    //         SW: rd[0]
    //       },
    //       interval: 2, // 6° 一个间隔；间隔越小，台风圈越平滑
    //       color: levels[level]
    //     }
    //     this.drawWindCircle(config, vectorSource)
    //   }
    // }
    // console.log(vectorSource)
    return { vectorSource: vectorSource, lastPoint: this.lastPoint };
  }

  getTyphoonGifStyle(options) {
    return new Style({
      image: new Icon({
        ...options,
        scale: options.scale || 1.2,
        anchor: [0.5, 0.5],
        opacity: 0.95,
      }),
      zIndex: 10,
    });
  }

  setTyphoonGifIcon(feature, gifUrl) {
    feature.setStyle(
      this.getTyphoonGifStyle({
        src: gifUrl,
      }),
    );
    feature.changed();

    if (!window.gifler) {
      return;
    }
    const canvas = document.createElement("canvas");
    window.gifler(gifUrl).frames(
      canvas,
      (ctx, frame) => {
        if (canvas.width !== frame.width || canvas.height !== frame.height) {
          canvas.width = frame.width;
          canvas.height = frame.height;
        }
        ctx.clearRect(0, 0, frame.width, frame.height);
        ctx.drawImage(frame.buffer, frame.x, frame.y);
        feature.setStyle(
          this.getTyphoonGifStyle({
            img: canvas,
            imgSize: [frame.width, frame.height],
          }),
        );
        feature.changed();
      },
      true,
    );
  }

  drawWindCircle(config, vectorSource) {
    const wktformat = new format.WKT();
    let wkt = "POLYGON((";
    let wkt0 = "";
    for (let i = 0; i < 360 / config.interval; i++) {
      let r = 0;
      const ang = i * config.interval;
      // 第一象限
      if (ang > 0 && ang <= 90) {
        r = config.r.NE;
      } else if (ang > 90 && ang <= 180) {
        // 第二象限
        r = config.r.NW;
      } else if (ang > 180 && ang <= 270) {
        // 第三象限
        r = config.r.SW;
      } else {
        // 第四象限
        r = config.r.SE;
      }
      const x = config.x + r * Math.cos((ang * Math.PI) / 180);
      const y = config.y + r * Math.sin((ang * Math.PI) / 180);
      wkt = wkt + `${x} ${y},`;
      if (i === 0) {
        wkt0 = `${x} ${y}`;
      }
    }
    wkt = wkt + wkt0 + "))";
    const feature = wktformat.readFeature(wkt);
    feature.setStyle(
      new Style({
        stroke: new Stroke({
          color: "#fff",
        }),
        // fill: new Fill({
        //   color: 'rgba(50,55,50,0.1)'
        // })
      }),
    );
    vectorSource.addFeature(feature);
    // vectorSource.addFeature(wktformat.readFeature("POINT(" + config.x + " " + config.y + ")"));
  }
}
export default Typhoon;
